var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticStyle: { "margin-top": "-20px" } },
        [
          _c("v-subheader", [
            _c("b", [_vm._v(_vm._s(_vm.$t("TEMPLATE LIST")))])
          ])
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 type3",
          attrs: {
            headers: _vm.templateHeaders,
            items: _vm.initaldata,
            "item-key": "uniqueid",
            "hide-default-footer": true,
            height: "417",
            "items-per-page": 2000,
            "single-select": ""
          },
          on: { "click:row": _vm.getpreview },
          scopedSlots: _vm._u(
            [
              {
                key: "item.icon",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _vm.permissionSetValue == "company" &&
                    item.templateName != ""
                      ? _c(
                          "v-icon",
                          {
                            staticStyle: { color: "red" },
                            attrs: { medium: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteSelectedTemplate(item)
                              }
                            }
                          },
                          [_vm._v("mdi-close-circle ")]
                        )
                      : _vm.permissionSetValue == "country" &&
                        item.areaKey !== "company" &&
                        item.templateName != ""
                      ? _c(
                          "v-icon",
                          {
                            staticStyle: { color: "red" },
                            attrs: { medium: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteSelectedTemplate(item)
                              }
                            }
                          },
                          [_vm._v("mdi-close-circle ")]
                        )
                      : _vm.permissionSetValue == "region" &&
                        item.areaKey !== "country" &&
                        item.areaKey !== "company" &&
                        item.templateName != ""
                      ? _c(
                          "v-icon",
                          {
                            staticStyle: { color: "red" },
                            attrs: { medium: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteSelectedTemplate(item)
                              }
                            }
                          },
                          [_vm._v("mdi-close-circle ")]
                        )
                      : _vm.permissionSetValue == "city" &&
                        item.areaKey !== "country" &&
                        item.areaKey !== "company" &&
                        item.areaKey !== "region" &&
                        item.templateName != ""
                      ? _c(
                          "v-icon",
                          {
                            staticStyle: { color: "red" },
                            attrs: { medium: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteSelectedTemplate(item)
                              }
                            }
                          },
                          [_vm._v("mdi-close-circle ")]
                        )
                      : _vm.permissionSetValue == "store" &&
                        item.templateName != "" &&
                        item.areaKey !== "country" &&
                        item.areaKey !== "company" &&
                        item.areaKey !== "region" &&
                        item.area !== "City"
                      ? _c(
                          "v-icon",
                          {
                            staticStyle: { color: "red" },
                            attrs: { medium: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteSelectedTemplate(item)
                              }
                            }
                          },
                          [_vm._v("mdi-close-circle ")]
                        )
                      : _c("span", [_c("v-icon")], 1)
                  ]
                }
              },
              {
                key: "item.action",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    (_vm.permissionSetValue == "company" &&
                      item.templateName != "") ||
                    (_vm.permissionSetValue == "country" &&
                      item.areaKey !== "company" &&
                      item.templateName != "") ||
                    (_vm.permissionSetValue == "region" &&
                      item.areaKey !== "country" &&
                      item.areaKey !== "company" &&
                      item.templateName != "") ||
                    (_vm.permissionSetValue == "city" &&
                      item.areaKey !== "country" &&
                      item.areaKey !== "company" &&
                      item.areaKey !== "region" &&
                      item.templateName != "") ||
                    (_vm.permissionSetValue == "store" &&
                      item.templateName != "" &&
                      item.areaKey !== "country" &&
                      item.areaKey !== "company" &&
                      item.areaKey !== "region" &&
                      item.area !== "City")
                      ? _c("img", {
                          staticStyle: {
                            "margin-right": "15px",
                            height: "18px",
                            cursor: "pointer"
                          },
                          attrs: {
                            src: _vm.isSelectedRow(item)
                              ? require("@/assets/img/ico_down.svg")
                              : require("@/assets/img/ico_down_popup.svg")
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.downloadSelectedTemplate(item)
                            }
                          }
                        })
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.templateName",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.templateName
                      ? _c("span", [_vm._v(_vm._s(item.templateName))])
                      : _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            margin: "auto !important",
                            display: "flex"
                          },
                          attrs: {
                            width: "20",
                            height: "20",
                            src: _vm.isSelectedRow(item)
                              ? require("@/assets/img/ico_upload.svg")
                              : require("@/assets/img/ic_upload.svg")
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.handleOpenSelectTemplateTypeFile(item)
                            }
                          }
                        })
                  ]
                }
              },
              {
                key: "item.areaKey",
                fn: function(ref) {
                  var item = ref.item
                  return [_c("span", [_vm._v(_vm._s(_vm.$t(item.areaKey)))])]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.template_list,
            callback: function($$v) {
              _vm.template_list = $$v
            },
            expression: "template_list"
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("No data available")))])
          ])
        ],
        2
      ),
      _c(
        "v-row",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn ml-2",
              attrs: {
                disabled: _vm.saveButtonDisabled || _vm.btndisabled,
                text: ""
              },
              on: {
                click: function($event) {
                  return _vm.saveSelectedTemplateList()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Save")))]
          ),
          _c(
            "v-btn",
            {
              staticClass: "btn ml-2",
              attrs: {
                disabled: !_vm.saveButtonDisabled || _vm.btndisabled,
                text: ""
              },
              on: {
                click: function($event) {
                  return _vm.ReapplySelectedTemplateList()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Reapply")))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", width: "500" },
              model: {
                value: _vm.UploadOptions,
                callback: function($$v) {
                  _vm.UploadOptions = $$v
                },
                expression: "UploadOptions"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "popup add_store_popup",
                  attrs: { align: "center", justify: "center" }
                },
                [
                  _c("v-card-title", [
                    _c("h3", { staticClass: "page-title-bar" }, [
                      _c("i", { staticClass: "ico ico-template" }),
                      _vm._v(_vm._s(_vm.$t("Template Upload Option")) + " ")
                    ])
                  ]),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-container",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                                margin: "-50px"
                              }
                            },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  model: {
                                    value: _vm.selectedOption,
                                    callback: function($$v) {
                                      _vm.selectedOption = $$v
                                    },
                                    expression: "selectedOption"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "" + _vm.$t("Upload Now"),
                                      value: "false"
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "" + _vm.$t("Upload Later"),
                                      value: "true"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "d-flex justify-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: { text: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleClickConfirm()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Save")))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: { text: "", icon: "" },
                          on: {
                            click: function($event) {
                              _vm.UploadOptions = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Cancel")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "680" },
          model: {
            value: _vm.openSelectTemplateTypeFileDialog,
            callback: function($$v) {
              _vm.openSelectTemplateTypeFileDialog = $$v
            },
            expression: "openSelectTemplateTypeFileDialog"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "popup add_store_popup",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("h3", { staticClass: "page-title-bar" }, [
                    _c("img", {
                      staticClass: "Upload_Ico",
                      attrs: { src: require("@/assets/img/ic_upload.svg") }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("Template Upload")) + " ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "mb-10",
                      staticStyle: { color: "#001e38", "font-size": "14px" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedTemplateTypeRow["areaKey"]) +
                          " : " +
                          _vm._s(_vm.selectedTemplateTypeRow["areaValue"]) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _c("v-card-text", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center justify-space-between mb-2"
                  },
                  [
                    _c("div", { staticClass: "mr-5 " }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("Template Type")))])
                    ]),
                    _c("div", { staticClass: "fake-input-box" }, [
                      _vm._v(
                        " " + _vm._s(_vm.selectedTempalteType.typeName) + " "
                      ),
                      _c("div", { staticClass: "tempsize" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedTempalteType.templateSize) +
                            " "
                        )
                      ])
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center justify-space-between mb-2"
                  },
                  [
                    _c("div", { staticClass: "mr-5 " }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("XSL File")))]),
                      _c(
                        "span",
                        { staticStyle: { color: "red", "margin-left": "5px" } },
                        [_vm._v("*")]
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "fake-input-box",
                        staticStyle: {
                          "background-color": "white",
                          border: "none"
                        }
                      },
                      [
                        _c("v-file-input", {
                          staticClass: "form-file fileinput",
                          attrs: {
                            accept: "text/xml",
                            dense: "",
                            clearable: false,
                            placeholder: _vm.$t("Select XSL File") + " *"
                          },
                          on: {
                            change: function(file) {
                              return _vm.encodeFile(file, "xsl")
                            }
                          },
                          model: {
                            value: _vm.selectedXslFile,
                            callback: function($$v) {
                              _vm.selectedXslFile = $$v
                            },
                            expression: "selectedXslFile"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center justify-space-between mb-2"
                  },
                  [
                    _c("div", { staticClass: "mr-5 " }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("JSON File")))]),
                      _c("span", { staticStyle: { "margin-left": "5px" } }, [
                        _c("sup", [
                          _vm._v("(" + _vm._s(_vm.$t("Optional")) + ")")
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "fake-input-box",
                        staticStyle: {
                          "background-color": "white",
                          border: "none"
                        }
                      },
                      [
                        _c("v-file-input", {
                          staticClass: "form-file fileinput",
                          attrs: {
                            accept: "application/json",
                            dense: "",
                            clearable: false,
                            placeholder: "" + _vm.$t("Select JSON File")
                          },
                          on: {
                            change: function(file) {
                              return _vm.encodeFile(file, "json")
                            }
                          },
                          model: {
                            value: _vm.selectedJsonFile,
                            callback: function($$v) {
                              _vm.selectedJsonFile = $$v
                            },
                            expression: "selectedJsonFile"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: {
                        text: "",
                        icon: "",
                        disabled: !_vm.selectedXslFile
                      },
                      on: { click: _vm.handleConfirmSelectTemplateTypeFile }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Select")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: { click: _vm.cancelSelectTemplateTypeFile }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "500" },
          model: {
            value: _vm.TemplateDownloadModel,
            callback: function($$v) {
              _vm.TemplateDownloadModel = $$v
            },
            expression: "TemplateDownloadModel"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "popup add_store_popup",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c("v-card-title", [
                _c("h3", { staticClass: "page-title-bar" }, [
                  _c("img", {
                    staticStyle: { "margin-right": "15px", height: "30px" },
                    attrs: { src: require("@/assets/img/ico_down_popup.svg") }
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("Download")) + " "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        position: "absolute",
                        right: "40px",
                        top: "66px",
                        "max-width": "160px",
                        "white-space": "normal",
                        "word-break": "break-all",
                        "text-align": "left"
                      }
                    },
                    [
                      _c("b", [_vm._v(_vm._s(_vm.$t("TypeName")) + " :")]),
                      _vm._v(
                        " " + _vm._s(_vm.selectedTempalteType.typeName) + " "
                      ),
                      _c("br"),
                      _c("b", [_vm._v(_vm._s(_vm.$t("AreaLevel")) + " :")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.downloadedItem && _vm.downloadedItem["areaKey"]
                          )
                      ),
                      _c("br"),
                      _c("b", [_vm._v(_vm._s(_vm.$t("AreaValue")) + " :")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.downloadedItem &&
                              _vm.downloadedItem["areaValue"]
                          ) +
                          " "
                      )
                    ]
                  )
                ])
              ]),
              _c(
                "v-card-text",
                {
                  staticClass: "text-center",
                  staticStyle: { "margin-top": "10px" }
                },
                [
                  _c("p", { staticStyle: { "text-align": "justify" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Please select the format to download the template file"
                        )
                      ) + " "
                    )
                  ])
                ]
              ),
              _c("br"),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-container",
                        {
                          staticStyle: {
                            "justify-content": "center",
                            margin: "-50px"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "text-align": "justify",
                                color: "rgba(0, 0, 0, 0.6)",
                                "font-size": "13px"
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.$t("Select type")) + " "),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*")
                              ])
                            ]
                          ),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.selectedOptionDown,
                                callback: function($$v) {
                                  _vm.selectedOptionDown = $$v
                                },
                                expression: "selectedOptionDown"
                              }
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "" + _vm.$t("XSL"), value: "1" }
                              }),
                              _c("v-radio", {
                                attrs: {
                                  disabled: !_vm.canUseJson,
                                  label: "" + _vm.$t("Json"),
                                  value: "2"
                                }
                              }),
                              _c("v-radio", {
                                attrs: {
                                  disabled: !_vm.canUseJson,
                                  label: "" + _vm.$t("Both"),
                                  value: "3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.todownloadTemplateFile()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Download")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.TemplateDownloadModel = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }